/* ============================================================
   FarachArt — Entry Point
   
   All CSS and JS modules are imported here.
   Webpack bundles everything into optimized output.
   ============================================================ */

// --- CSS Imports (order matters for cascade) ---
import './css/variables.css';
import './css/base.css';
import './css/cursor.css';
import './css/nav.css';
import './css/hero.css';
import './css/carousel.css';
import './css/deck.css';
import './css/about.css';
import './css/contact.css';
import './css/modal.css';
import './css/spinner.css';
import './css/responsive.css';

// Plyr's own CSS (from node_modules)
import 'plyr/dist/plyr.css';

// --- JS Module Imports ---
import { initThreeScene } from './js/three-scene';
import { initModal } from './js/modal';
import { initCarousel } from './js/carousel';
import { initDeck } from './js/deck';
import { initCursor } from './js/cursor';
import { initScrollAnimations } from './js/scroll-animations';
import { initContactForm } from './js/contact';

/**
 * Boot sequence — initializes all interactive modules.
 */
async function boot() {
  // 1. Background particles
  initThreeScene();

  // 2. Modal (returns openModal callback for carousel/deck)
  const { openModal } = initModal();

  // 3. Portfolio showcases (async — fetch JSON data)
  const { CA_CONTAINER } = await initCarousel(openModal);
  const { deckContainer } = await initDeck(openModal);

  // 4. Custom cursor (register interactive zones)
  const { registerCursor } = initCursor();
  // Zones disabled upon request

  // 5. Scroll-triggered animations
  initScrollAnimations();

  // 6. Contact Form Submission Handling
  initContactForm();
}

boot();
